/**
 * Cookie-consent notice.
 *
 * - Site-wide bottom notice with a single "Aceptar".
 * - The banner is hidden by default in CSS and shown only when there is no
 *   stored consent for the current VERSION. The choice persists in
 *   localStorage ('ligo-cookie-consent' = VERSION).
 * - Exposes window.ligoCookies + a 'ligo:cookie-consent' document event so
 *   Google Analytics / HubSpot can be wired to consent later. Scripts are NOT
 *   gated today (notice model) — the hook is dormant but available.
 */
const STORAGE_KEY = 'ligo-cookie-consent'
const VERSION = '1' // bump to re-prompt everyone after a material policy change

const pending = []

function read() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (e) {
    return null
  }
}

function hasConsent() {
  return read() === VERSION
}

function notify() {
  document.dispatchEvent(
    new CustomEvent('ligo:cookie-consent', { detail: { version: VERSION } })
  )
  while (pending.length) {
    try {
      pending.shift()()
    } catch (e) {
      console.error('[ligoCookies] onConsent callback threw:', e)
    }
  }
}

function onConsent(cb) {
  if (typeof cb !== 'function') return
  if (hasConsent()) {
    try { cb() } catch (e) { console.error('[ligoCookies] onConsent callback threw:', e) }
  } else {
    pending.push(cb)
  }
}

function accept(banner) {
  if (hasConsent()) return
  try {
    localStorage.setItem(STORAGE_KEY, VERSION)
  } catch (e) {}
  if (banner) banner.classList.remove('is-visible')
  notify()
}

window.ligoCookies = { hasConsent, onConsent }

function init() {
  const banner = document.querySelector('[data-cookie-banner]')

  if (hasConsent()) {
    notify() // already-consented visitor: keep banner hidden, fire the hook
    return
  }

  if (!banner) return

  banner.classList.add('is-visible')
  banner.querySelectorAll('[data-cookie-accept]').forEach((btn) => {
    btn.addEventListener('click', () => accept(banner))
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
